import configs from '../configs'

export const isDevelopmentMode = process.env.NODE_ENV === 'development'
export const isPerformanceTestEnv =
  configs.CLIENT_ENV === 'lb-dev' ||
  configs.CLIENT_ENV === 'lb-uat' ||
  configs.CLIENT_ENV === 'lb-sat'
export const isProductionMode =
  /*configs.CLIENT_ENV === 'lb-uat' || */ configs.CLIENT_ENV === 'rc' ||
  configs.CLIENT_ENV === 'real'
export const isBrowser = (process as any)['browser'] === true
export const isLocalhost = /^http:\/\/localhost/.test(window.location.origin)
